import React, { FC } from 'react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import {AnketaIcon, QrCode} from '../../assets';
import styles from './styles/index.module.scss';

interface IToastPrintCertificate {
  data: any,
  props?: any
}
enum TYPE {
  MODAL,
  TABLE
}
const ToastPrintCertificate: FC<IToastPrintCertificate> = ({ data }) => {

  function getLink(dataVers: any) {
    switch (dataVers?.type) {
      case TYPE.MODAL:
        return { pdfLink: dataVers[0].certificate_pdf, qrLink: dataVers[0].qr_label };
      case TYPE.TABLE:
        return { pdfLink: dataVers.arr[dataVers.arr.length - 1].certificate_pdf, qrLink: dataVers.arr[dataVers.arr.length - 1].qr_label };
      default:
        return { pdfLink: dataVers[0].certificate_pdf, qrLink: dataVers[0].qr_label };
    }
  }

  return (
      <>          
        {getLink(data)?.pdfLink &&
          <button 
            className={styles['toast-info']} 
            onClick={() => { window.open(getLink(data)?.pdfLink) }}
            type='button' 
          >
            <GxIcon src={AnketaIcon} className={styles['toast-info--icon']}/>
            <span className={styles['toast-info--text']}>Печать сертификата (в новой вкладке)</span>
          </button>
        }
        {getLink(data)?.qrLink &&
          <button
            className={styles['toast-info']}
            onClick={() => { window.open(getLink(data)?.qrLink) }}
            type='button'
          > 
            <GxIcon src={QrCode} className={styles['toast-info--icon']}/>
            <span className={styles['toast-info--text']}>Печать QR-этикетки (в новой вкладке)</span>
          </button>
        }
     </>
  );
};

export default ToastPrintCertificate;